import { get } from "lodash";

export const selectUpdateUserPoints = state =>
  get(state, "user.updateUserPoints", false);
